import { Text } from "@simplybusiness/mobius";

export function NoQuotesCard() {
  return (
    <div
      role="listitem"
      className="mobius-no-quotes-card"
      data-testid="no-quotes-card"
    >
      <div className="mobius-no-quotes-card__body">
        <Text elementType="h2">Let&apos;s try this again</Text>
        <Text>
          Sorry, it doesn&apos;t look like we have anyone who can cover the
          limits you&apos;ve selected. Not to worry. If you change your coverage
          limits above, you may be able to see available quotes.
        </Text>
      </div>
    </div>
  );
}
